export default "__VITE_ASSET__96fdef83__"